import { Controller } from "@hotwired/stimulus"

export default class AutoReloadController extends Controller {
  static values = { delay: { type: Number, default: 500 } }

  declare delayValue: number

  connect(): void {
    setTimeout(() => {
      window.location.reload()
    }, this.delayValue)
  }
}
